/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const WebApiModelsEnumerationTypesEventState = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;
export type WebApiModelsEnumerationTypesEventState = typeof WebApiModelsEnumerationTypesEventState[keyof typeof WebApiModelsEnumerationTypesEventState];


export function WebApiModelsEnumerationTypesEventStateFromJSON(json: any): WebApiModelsEnumerationTypesEventState {
    return WebApiModelsEnumerationTypesEventStateFromJSONTyped(json, false);
}

export function WebApiModelsEnumerationTypesEventStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiModelsEnumerationTypesEventState {
    return json as WebApiModelsEnumerationTypesEventState;
}

export function WebApiModelsEnumerationTypesEventStateToJSON(value?: WebApiModelsEnumerationTypesEventState | null): any {
    return value as any;
}

